import { ChevronIcon } from "../../icons";
import { forwardRef } from "react";
import { cssModule, isNil, mergeProps, slot } from "../../shared";
import { useDisclosureContext } from "./DisclosureContext";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "svg";
export function InnerDisclosureArrow({
  forwardedRef,
  open,
  ...rest
}) {
  const disclosureContext = useDisclosureContext();
  const isOpen = open !== null && open !== void 0 ? open : disclosureContext === null || disclosureContext === void 0 ? void 0 : disclosureContext.isOpen;

  if (isNil(isOpen)) {
    throw new Error("The disclosure arrow component must receive a controlled prop \"open\" or have a parent DisclosureContext.");
  }

  return /*#__PURE__*/_jsx(ChevronIcon, { ...mergeProps(rest, {
      className: cssModule("o-ui-disclosure-arrow", isOpen ? "up" : "down"),
      ref: forwardedRef
    })
  });
}
InnerDisclosureArrow.defaultElement = DefaultElement;
export const DisclosureArrow = slot("icon", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerDisclosureArrow, { ...props,
  forwardedRef: ref
})));